/**
 * @module FE-CU23_見守り情報配信設定画面
 */
import Header from '../../../components/header/Header.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import Label from '../../../components/label/Label.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PcPageTitle from '@/components/pcPageTitle/PcPageTitle.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU23';
export default {
  name: 'WatcherInfo',
  components: {
    Header,
    ListPanel,
    Label,
    BreadCrumbList,
    PcPageTitle,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.見守り情報配信設定'), // "見守り情報配信設定",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.C0001'),
      //"見守り配信を、定期通報/定刻通報/異常通報の3つの中から設定を行うことができます。\n定期通報：定期的にセンサーの状態を通知\n定刻通報：決まった時間の通知と異常を通知\n異常通報：異常時に通知",
      displayAreaList: [],
      services: [
        {
          id: 1,
          text: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.定期連絡'), //"定期連絡",
        },
        {
          id: 2,
          text: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.異常通知'), //"異常通知",
        },
        {
          id: 3,
          text: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.定刻連絡'), // " 定刻連絡",
        },
      ],
      serviceTimeLabels: {
        1: '$vuetify.FECU23見守り情報配信設定画面.定期連絡', // "定期連絡",
        2: '$vuetify.FECU23見守り情報配信設定画面.異常通知', // "異常通知",
        3: '$vuetify.FECU23見守り情報配信設定画面.異常通知', // "異常通知",
      },
      // APIを反映させるデータ群
      notification: false,
      service: { id: 1, text: '定期連絡' },
      scheduledTime1: null,
      scheduledTime2: null,
      scheduledTime3: null,
      times: {
        first: {
          value: '',
          menu: false,
        },
        second: {
          value: '',
          menu: false,
        },
        third: {
          value: '',
          menu: false,
        },
      },
      monitorCheckbox: false,
      monitorTime: null,
      distributeCheckbox: false,
      distribute: {
        from: {
          value: '',
          menu: false,
        },
        to: {
          value: '',
          menu: false,
        },
      },

      // 表示制御・活性制御データ群
      notificationDisabled: false,
      valid: true,

      // エラー・バリデーションデータ群
      customerNumberError: '',
      rules: {
        scheduledTime1: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0002'),
          (value) =>
            /^[0-9]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0003'),

          (value) =>
            (5 <= value && value <= 900) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0004'),
        ],
        scheduledTime2: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0025'),

          (value) =>
            /^[0-9]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0026'),

          (value) =>
            (5 <= value && value <= 900) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0027'),
        ],
        scheduledTime3: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0028'),

          (value) =>
            /^[0-9]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0029'),

          (value) =>
            (5 <= value && value <= 900) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0030'),
        ],
        timesFirst: [
          // (value) =>
          //   !!value ||
          //   vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0005'),

          (value) =>
            /^[0-9:]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0006'),

          (value) =>
            this.timesValide(value, 1) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0007'),
        ],
        timesSecond: [
          (value) =>
            /^[0-9:]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0008'),

          (value) =>
            this.timesValide(value, 2) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0009'),
        ],
        timesThird: [
          (value) =>
            /^[0-9:]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0010'),

          (value) =>
            this.timesValide(value, 3) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0011'),
        ],
        monitorTime: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0012'),

          (value) =>
            /^[0-9]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0013'),

          (value) =>
            (1 <= value && value <= 99) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0014'),
        ],
        from: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0015'),

          (value) =>
            /^[0-9:]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0016'),
        ],
        to: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0018'),

          (value) =>
            /^[0-9:]*$/.test(value) ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0019'),
        ],
      },
      tmpDisplayAreaTitle: {
        place: '',
        type: '',
      },
      modified: '',
      isSuccessSecurityUnit: false,
      CONSTANTS: CONSTANTS,
      blurDateTimeFlg: false,
      timesEmptyMessage: '',
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  watch: {
    isAllTimesEmpty(newVal) {
      this.timesEmptyMessage = newVal
        ? this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0031')
        : '';
    },
  },
  computed: {
    isAllTimesEmpty() {
      return (
        this.blurDateTimeFlg &&
        !this.times.first.value &&
        !this.times.second.value &&
        !this.times.third.value
      );
    },
    isAvaiable() {
      return !this.isSuccessSecurityUnit;
      // return false;
    },
    isSettingBtn() {
      return this.setDisabledSettingBtn();
    },
    i18nItems(vm) {
      return {
        displayAreaTitle: {
          place: this.tmpDisplayAreaTitle.place,
          type: this.tmpDisplayAreaTitle.type,
          typeIsBefore: true,
        },
        title: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.見守り情報配信設定'), // "見守り情報配信設定",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.C0001'),
        //"見守り配信を、定期通報/定刻通報/異常通報の3つの中から設定を行うことができます。\n定期通報：定期的にセンサーの状態を通知\n定刻通報：決まった時間の通知と異常を通知\n異常通報：異常時に通知",
        displayAreaList: [],
        services: [
          {
            id: 1,
            text: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.定期連絡'), //"定期連絡",
          },
          {
            id: 2,
            text: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.異常通知'), //"異常通知",
          },
          {
            id: 3,
            text: vm.$vuetify.lang.t('$vuetify.FECU23見守り情報配信設定画面.定刻連絡'), // " 定刻連絡",
          },
        ],
      };
    },
    isAvaiableDistributeSetting() {
      return !this.isAvaiable && !this.distributeCheckbox;
    },
    scheduledTime: {
      get() {
        if (this.service.id == 1) {
          return this.scheduledTime1;
        } else if (this.service.id == 2) {
          return this.scheduledTime2;
        } else if (this.service.id == 3) {
          return this.scheduledTime3;
        }
      },
      set(value) {
        if (this.service.id == 1) {
          this.scheduledTime1 = value;
        } else if (this.service.id == 2) {
          this.scheduledTime2 = value;
        } else if (this.service.id == 3) {
          this.scheduledTime3 = value;
        }
      },
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 定刻連絡時刻のフォーカスが外れた場合にフラグを立てる処理
     */
    handleBlurDateTime() {
      this.blurDateTimeFlg = true;
    },
    /**
     * 見守り情報配信変更時の初期化処理
     */
    changeNotification() {
      if (!this.notification) {
        this.service = { id: 1, text: '定期連絡' };
        this.scheduledTime1 = null;
        this.scheduledTime2 = null;
        this.scheduledTime3 = null;
        this.times = {
          first: {
            value: '',
            menu: false,
          },
          second: {
            value: '',
            menu: false,
          },
          third: {
            value: '',
            menu: false,
          },
        };
        this.monitorCheckbox = false;
        this.monitorTime = null;
        this.distributeCheckbox = false;
        this.distribute = {
          from: {
            value: '',
            menu: false,
          },
          to: {
            value: '',
            menu: false,
          },
        };
      }
    },
    /**
     * 監視するチェックボックス変更時の初期化処理
     */
    changeMonitorCheckbox() {
      if (!this.monitorCheckbox) {
        this.monitorTime = null;
      }
    },
    /**
     * 配信時間を指定チェックボックス変更時の初期化処理
     */
    changeDistributeCheckbox() {
      if (!this.distributeCheckbox) {
        this.distribute = {
          from: {
            value: '',
            menu: false,
          },
          to: {
            value: '',
            menu: false,
          },
        };
      }
    },
    /**
     * 見守り情報配信設定入力可否変更処理
     * @param {Boolean} payload 見守り情報配信設定が入力可かどうか
     */
    setIsSuccessSecurityUnit(payload) {
      this.isSuccessSecurityUnit = payload;
    },
    /**
     * 配信時間指定時刻フォーマット処理
     * @param {String} dateString 配信時間指定時刻
     * @returns 配信時間指定時刻
     */
    formatDeliveryPossibleTime(dateString) {
      if (!dateString || dateString == '    ') {
        return '';
      } else {
        return dateString.slice(0, 2) + ':' + dateString.slice(2, 4);
      }
    },
    /**
     * 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    APP_CU2301: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlanId: 0,
            //       customerNumber: "aaaa",
            //       securityDestinationName: "aaaa",
            //       districtSplitNumber: "aaaa",
            //       districtSplitname: "aaaa",
            //       displayDistrictNickname: "aaaa",
            //     },
            //     sendCustomerNumber: "123456789",
            //     sendCommandKey: "123456789",
            //     watchOverDeliverySetting: {
            //       isUseDeliveryPossibleTime: true,
            //       deliveryPossibleTimeFrom: "0000",
            //       deliveryPossibleTimeTo: "2359",
            //     },
            //     modified: "2022-04-27 12:00:00",
            //   },
            // };
            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            const labels = {
              usagePlan:
                '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.利用プラン', //"利用プラン",
              customerNumber:
                '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.お客様番号', //"お客様番号",
              securityDestinationName:
                '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.警備先名', // "警備先名",
              districtSplitNumber:
                '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.地区番号', // "地区番号",
              districtSplitName:
                '$vuetify.FECU39新規サブユーザー登録画面仮登録.対象地区詳細表示領域.地区名', //"地区名",
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
            ];
            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };

            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU23見守り情報配信設定画面.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.displayAreaList = [
                  ...this.displayAreaList,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text.includes('$'),
                  },
                ];
              }
            });

            this.tmpDisplayAreaTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
              type: '$vuetify.FECU23見守り情報配信設定画面.対象地区',
              typeIsBefore: true,
            };

            this.modified = apiData.contentsInfo.modified;

            this.distributeCheckbox = apiData.contentsInfo.watchOverDeliverySetting
              .isUseDeliveryPossibleTime
              ? true
              : false;
            if (this.distributeCheckbox) {
              if (apiData.contentsInfo.watchOverDeliverySetting.deliveryPossibleTimeFrom) {
                this.distribute.from.value = this.formatDeliveryPossibleTime(
                  apiData.contentsInfo.watchOverDeliverySetting.deliveryPossibleTimeFrom
                );
              }
              if (apiData.contentsInfo.watchOverDeliverySetting.deliveryPossibleTimeTo) {
                this.distribute.to.value = this.formatDeliveryPossibleTime(
                  apiData.contentsInfo.watchOverDeliverySetting.deliveryPossibleTimeTo
                );
              }
            }
          },
          (error /* eslint-disable-line */) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU2301>>>");
      return apiData;
    },
    /**
     * 見守り配信設定更新API実行処理
     * @returns apiData レスポンス
     */
    APP_CU2302: async function () {
      let method = 'post';
      let param = '/api/watchOverInfoDeliverySetting/update';
      // let param = "post"; // 検証用
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        watchOverSetting: {
          isWatchOverDelivery: this.notification,
          watchOverCause: this.notification ? this.service.id : 0,
          watchOverTimer: Number(this.scheduledTime),
          scheduleSetting: {
            time1:
              this.times.first.value === null || this.times.first.value === ''
                ? '    '
                : this.times.first.value.replace(':', ''),
            time2:
              this.times.second.value === null || this.times.second.value === ''
                ? '    '
                : this.times.second.value.replace(':', ''),
            time3:
              this.times.third.value === null || this.times.third.value === ''
                ? '    '
                : this.times.third.value.replace(':', ''),
          },
          forgetFlg: this.monitorCheckbox ? true : false,
          forgetTimer: Number(this.monitorTime),
        },
        watchOverDeliverySetting: {
          isUseDeliveryPossibleTime: this.distributeCheckbox,
          deliveryPossibleTimeFrom:
            this.distribute.from.value === null
              ? null
              : this.distribute.from.value.replace(':', ''),
          deliveryPossibleTimeTo:
            this.distribute.to.value === null ? null : this.distribute.to.value.replace(':', ''),
        },
        modified: this.modified,
      };

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "123456789",
            //     sendCommandKey: "123456",
            //   },
            // };
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('400')) {
              // エラーダイアログを表示
              this.$errorDialog('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0001');
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        );
      // console.log("APP_CU2302>>>");
      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認(APP_CU2301)API実行処理
     * @param {*} params リクエストのパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2301_CO9915: async function (params) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu2301: {
          //         watchOverSetting: {
          //           isWatchOverDelivery: true,
          //           watchOverCause: 3,
          //           watchOverTimer: 100,
          //           scheduleSetting: {
          //             time1: "    ",
          //             time2: "    ",
          //             time3: "    ",
          //           },
          //           forgetFlg: true,
          //           forgetTimer: 60,
          //         },
          //       },
          //     },
          //   },
          // };
          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            this.setIsSuccessSecurityUnit(true);

            // 2回目以降の場合、取得したデータをマッピング
            let watchOverSetting =
              apiData.contentsInfo.commandExecutionResult.app_cu2301.watchOverSetting;
            this.notification = watchOverSetting.isWatchOverDelivery;
            if (this.notification === false) {
              this.distributeCheckbox = false;
              this.distribute.from.value = '';
              this.distribute.to.value = '';
            }
            switch (watchOverSetting.watchOverCause) {
              case 1:
                this.service = { id: 1, text: '$vuetify.FECU23見守り情報配信設定画面.定期連絡' };
                break;
              case 2:
                this.service = { id: 2, text: '$vuetify.FECU23見守り情報配信設定画面.異常通知' };
                break;
              case 3:
                this.service = { id: 3, text: '$vuetify.FECU23見守り情報配信設定画面.定刻連絡' };
                break;
              default:
                break;
            }
            this.scheduledTime = watchOverSetting.watchOverTimer;
            this.times.first.value = this.formatDeliveryPossibleTime(
              watchOverSetting.scheduleSetting.time1
            );
            this.times.second.value = this.formatDeliveryPossibleTime(
              watchOverSetting.scheduleSetting.time2
            );
            this.times.third.value = this.formatDeliveryPossibleTime(
              watchOverSetting.scheduleSetting.time3
            );
            this.monitorCheckbox = watchOverSetting.forgetFlg ? true : false;
            this.monitorTime = watchOverSetting.forgetTimer;
          } else {
            this.setIsSuccessSecurityUnit(false);
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU2301_CO9915>>>");
      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認(APP_CU2302)API実行処理
     * @param {*} params リクエストのパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2302_CO9915: async function (params) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu2302: {
          //         requestResult: 0,
          //       },
          //     },
          //   },
          // };

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            if (apiData.contentsInfo.commandExecutionResult.app_cu2302.requestResult == 0) {
              this.callMessageDialog('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.C0003');
            } else {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.E0001');
            }
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        });
      // console.log("APP_CU2302_CO9915>>>");
      return apiData;
    },
    /**
     * 設定ボタンの活性制御
     * @returns 設定ボタンが活性かどうか
     */
    setDisabledSettingBtn() {
      if (this.notification === false) {
        // 見守り情報配信で使用しないが選択されている
        return false;
      } else {
        // 見守り情報配信で使用するが選択されている
        if (
          this.scheduledTime !== null &&
          this.scheduledTime !== '' &&
          !isNaN(Number(this.scheduledTime)) &&
          5 <= Number(this.scheduledTime) &&
          Number(this.scheduledTime) <= 900 &&
          ((this.service.id === 3 &&
            (this.times.first.value !== '' ||
              this.times.second.value !== '' ||
              this.times.third.value !== '') &&
            !(
              this.times.first.value === this.times.second.value && this.times.first.value !== ''
            ) &&
            !(
              this.times.second.value === this.times.third.value && this.times.third.value !== ''
            ) &&
            !(
              this.times.third.value === this.times.first.value && this.times.third.value !== ''
            )) ||
            this.service.id !== 3) &&
          ((this.monitorCheckbox === true && 1 <= this.monitorTime && this.monitorTime <= 99) ||
            this.monitorCheckbox === false) &&
          ((this.distributeCheckbox === true &&
            this.distribute.from.value !== '' &&
            this.distribute.to.value !== '') ||
            this.distributeCheckbox === false)
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    /**
     * 定刻連絡時刻に同じ時刻が入力されていないかのバリエーションチェック
     * @param {String} value 定刻連絡時刻
     * @param {Number} timeNumber 定刻連絡時刻ナンバー
     * @returns
     */
    timesValide(value, timeNumber) {
      switch (timeNumber) {
        case 1:
          if (
            value != '' &&
            (value === this.times.second.value || value === this.times.third.value)
          ) {
            return false;
          }
          break;
        case 2:
          if (
            value != '' &&
            (value === this.times.first.value || value === this.times.third.value)
          ) {
            return false;
          }
          break;
        case 3:
          if (
            value != '' &&
            (value === this.times.first.value || value === this.times.second.value)
          ) {
            return false;
          }
          break;
        default:
          break;
      }
      return true;
    },
    /**
     * メッセージダイアログ呼び出し処理
     * @param {String} text メッセージ
     */
    async callMessageDialog(text) {
      await this.$informationDialog(text);

      this.back();
    },
    /**
     * 登録確認ダイアログ呼び出し処理
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU23見守り情報配信設定画面.C0004',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
        // "確認",
        // "設定された内容は全ての対象地区へ反映されます。\n\r設定された内容で登録します。\n\rよろしいでしょうか。",
        // "いいえ",
        // "はい"
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.$_setLoading(true);
        let apiData = await this.APP_CU2302();

        if (typeof apiData.contentsInfo !== 'undefined') {
          let params = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo'),
            sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
            sendCommandKey: apiData.contentsInfo.sendCommandKey,
            apiId: 15,
            alarmType: 0,
            districtSplitNumber: this.$store.state.districtSplitNumber,
            securityAreaId: '',
          };
          await this.APP_CU2302_CO9915(params);
        }
        this.$_setLoading(false);
      }
    },
    /**
     * 戻る処理
     */
    back() {
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      this.$router.back();
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    let method = 'post';
    let param = '/api/watchOverInfoDeliverySetting/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    let apiData = await this.APP_CU2301(param, queries, method);

    if (typeof apiData.contentsInfo !== 'undefined') {
      let params = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.sendCommandKey,
        apiId: 14,
        alarmType: 0,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        securityAreaId: '',
      };
      await this.APP_CU2301_CO9915(params);
    }
  },
};
